// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3TdhH","label":"Labeled_label__1m2j4","divider":"Labeled_divider__44q5w"};